import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
  getRouteSheets () {
   return Api().get("/route-sheets/");
  },
  updateRouteSheet (params) {
    return Api().put("/route-sheets/",params);
  },
  addRouteSheet (params) {
    return Api().post("/route-sheets/",params);
  },
  getRouteSheet (params) {
    return Api().get("/route-sheets/"+params);
  },
  deleteRouteSheet (params) {
    return Api().delete("/route-sheets/"+params);
  },
  findByCompanyId (params) {
    return Api().get("/findByCompanyId/"+params);
  },
  deleteByCompany (params) {
    return Api().delete("/deleteByCompany/"+params);
  },
}



// WEBPACK FOOTER //
// ./src/services/RouteSheetService.js